import { Component } from '@angular/core';
import { SonaIconComponent } from '@sona/angular-ui-components';

@Component({
    selector: 'hlm-menu-item-sub-indicator',
    imports: [ SonaIconComponent ],
    template: `
        <sona-icon class="tw-ml-4 tw-text-muted-foreground" name="caret-right" size="tiny" />
	`,
    host: {
        class: 'tw-inline-block'
    }
})
export class HlmMenuItemSubIndicatorComponent {

}
